import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";
import { QuestionFormLog } from "./QuestionFormTypes";

export interface CvpGetQuestionFormLogsResponse extends BackendResponse {
  items: QuestionFormLog[];
}

export interface CvpGetQuestionFormLogsParameters extends NextApiParams {}

export const getQuestionFormLogs = withNextApi<
  CvpGetQuestionFormLogsResponse,
  CvpGetQuestionFormLogsParameters
>("/cvp/CvpGetQuestionFormLogs", { method: "GET" });
